import React from "react";
import type { FooterItem } from "@shared/graphql.types";
import { footerMenuItem } from "./FooterMenuItem.css";

interface Props {
  item: FooterItem;
}

export const FooterMenuItem: React.FC<Props> = ({ item }) => {
  return (
    <a
      href={item.href}
      target={item.href.startsWith("http") ? "_blank" : undefined}
      rel={item.href.startsWith("http") ? "noreferrer" : ""}
      className={footerMenuItem}
      data-testid="footer-menuitem"
    >
      {item.title}
    </a>
  );
};
